module.exports = __webpack_public_path__ + "static/media/order_pay.69c7bcdd.svg";